import { render, staticRenderFns } from "./SentEmailDialog.vue?vue&type=template&id=07737c0f&scoped=true&"
import script from "./SentEmailDialog.vue?vue&type=script&lang=ts&"
export * from "./SentEmailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07737c0f",
  null
  
)

export default component.exports